import uuid from 'uuid/v1';

export const tabId = uuid();
